<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="title">About</h1>

        <vue-simple-markdown :source="abouttext"></vue-simple-markdown>
        <br>
        <a :href="'mailto:simon@simonreeves.com'">simon@simonreeves.com</a>
      </div>
    </section>
  </div>

</template>

<script>

    export default {
        data() {
            return {
              abouttext: `
## I have been working in 3D since studying graphic and 3D design at art college in 2000.

## I have always had a passion for image making - I enjoy the creating process, the craft, the aesthetic and the technical. My work is often driven by ideas on exploring a new techniques or styles
---
After college in 2003 I studied digital animation producing 2 short films at the University of Hertfordshire as well as my first freelance commissions before graduating. 
I moved straight to London and another 5 years of freelance working for various clients myself and at many of the major studios such as The Mill, Glassworks & Passion Pictures.

In 2011 I started at Analog where as head of 3D I have had the room to explorer deeper technical approaches to client work, while developing an effeceint pipeline and workflow as well as working creativly on projects internally and externally.

## Knowledge base
 - Main package is Houdini, formally XSI, former to that 3dsmax
 - Compositing in Nuke
 - Faster learner and always open to other packages and workflows eg. substance
 - Python for pipeline, Houdini, Maya, XSI, Nuke, Deadline, Windows standalone apps, Django
 - Web pages for tools and personal use (this site) now primarily Django/Vue, formerly PHP, ajax, javascript


  -  2011 - present : Head of 3D [Analog](http://analogstudio.co.uk)
  -  2006 - 2011 : Various freelance roles
`
            }
        },
    }
</script>

<style lang="scss" scoped>

  @import '~bulma/sass/utilities/_all';
  @import '../assets/sass/main.scss';

  .section, .title {
    padding: 1em 0;
    width: 50vw;
    margin-left: auto;
    margin-right: auto;
  }
  .title {
    text-align: center;
  }

  @include mobile {
    .section, .title {
      padding: 1em 1rem;
      width: 100%;
    }
  }
</style>
